module.exports = __webpack_public_path__ + "static/crosslink-investigation-10957659fa982769bc3362e696062a92.jpg";